import i18next from 'i18next';

export const isRtl = () => {
  // At the moment to be consistebt with AppSource we are not going to display right to left.
  return false;
  //return i18next.language === "he";
};
